import React, { Component } from 'react';
import { CustomCard } from "../../../../components/Card/CustomCard";
import { Timeline, Event } from "react-timeline-scribble";
import RecaudosReg from "../../../../shared/RecaudosReg";

class Reinscrip extends Component {
    recaudosRegulares = () => {
        return (
            RecaudosReg.map(option => (
                <Event interval={
                    <div className="fuente-monserrat" style ={{fontSize:14, color: "#333", marginBottom: -1}} key ={option.id}>{option.recaudo}</div>
                }></Event>
            ))
        )
    }

    contenido = () => (
        <React.Fragment>
            <div id="reinscripcion">
                <div className="fuente-monserrat" style ={{fontSize:18, color: "#1f2f6e", marginTop:-10, paddingLeft:25, marginBottom:30}}><strong>Reinscripciones (Estudiantes Regulares)</strong></div>
                <Timeline>
                    {this.recaudosRegulares()}
                </Timeline>
            </div>
            <div style={{minHeight: "73vh"}}>
                <div className="fuente-monserrat" style ={{fontSize:16, color: "#a80012", marginTop:30, paddingLeft:25}}><strong>Instructivo de Inscripción 2023-II</strong></div>
                <div className="custom-mt-10 fuente-monserrat" align="left" style={{color: "fff", padding: 25}}>
                    <a className="btn btn-danger fuente-monserrat" href="docs/INSTRUCTIVO_REINSCRICIONES_ESTUDIANTES_REGULARES_PERIODO_ACADEMICO_2023_II.pdf" target="_blank" style={{borderWidth: 1, borderColor:"#a80012", backgroundColor:"#a80012", color:"#FFF"}} title="Descargar el Plan de Estudios">Descargar Aquí <i className="fa fa-download"></i></a>
                </div>
            </div>
        </React.Fragment>
    )
    
    render() { 
        return (
            <CustomCard
                content={this.contenido()}
            />
        );
    }
}
 
export default Reinscrip;


// WEBPACK FOOTER //
// ./src/site/Componentes/Ingreso/Contenido/Reinscrip.jsx